import Repository, { baseURL } from "./Repository";

import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

const complaintApi = `${baseURL}`





export const branchlist = createAsyncThunk('branchlist',async(data)=>{
    return await Repository.post(`${baseURL}/branchlist`)
    .then(res => {
        //  return decrypter({data:res.data,key:"dFwcfDtdlb3522RG00143sfjmVtmdgsv"})
        return res.data
      }).catch(error =>{
          return error.response.data
       
      })
})
export const submitComplaint = createAsyncThunk('CRMAdd',async(data)=>{
    return await Repository.post(`${complaintApi}/CRMAdd`,{
        
        "Mobile":data.mobile,
        "Name":data.Name,
        "Branch":data.branch,
        "Fish_no":data.fishNum,
        "Sale_Date":data.date,
        "Text":data.description,
    })
    .then(res => {
        toast.success( res.data)
  
      }).catch(error =>{
        toast.error(error.response.data )
       
      })
})
export const complaintTracking = createAsyncThunk('CRMAdd',async(data)=>{
    return await Repository.post(`${complaintApi}/CRMGetAnswer?VerCode=${data}` )
    .then(res => {
        return res.data
      }).catch(error =>{
        toast.error(error.response.data )
       
      })
})